export enum HeroSectionLayoutOrder {
  TextLeftMediaRight = 'textLeftMediaRight',
  MediaLeftTextRight = 'mediaLeftTextRight',
}
